module.exports = __webpack_public_path__ + "img/Somewhere-Not-Rugged-But-Remote.feb5cc4d.jpg";